module.exports = __webpack_public_path__ + "img/logo-waterstart-100.e9b968ad.jpg";